import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M5 1h4v4M5 9H1V5" stroke="#A7A7A7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);